define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'vueRouter',
    'index2021-home/component/page-content',


    'css!index2021-home/index2021-home.css'
], function(
    Vue,
    i18n,
    PageMixin,
    VueRouter,
    PageContent
){
    Vue.use(VueRouter);

    var routes = [
        { path: '*', component: PageContent }
    ];
    var router = new VueRouter({
        routes: routes,
        mode: 'history',
        base: '/'
    });

    var app = new Vue({
        mixins: [PageMixin],
        router: router,
        i18n: i18n
    });
    app.$mount('#app');
});


//////////////////
// WEBPACK FOOTER
// ./index2021-home/main.js
// module id = 266
// module chunks = 6